import { FlexBox, Skeleton, Table } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';

/** Represents a skeleton row to be presented while the table is loading. */
export const SmsTableSkeletonRow = (): JSX.Element => {
  return (
    <Table.Tr>
      <Table.Td>
        <FlexBox gap={sizes.spacer['300']}>
          <Skeleton height="40px" width="40px" borderRadius="50%" />
          <Skeleton style={{ flexGrow: 1 }} />
        </FlexBox>
      </Table.Td>
      <Table.Td>
        <Skeleton height="20px" />
      </Table.Td>
      <Table.Td>
        <Skeleton height="20px" />
      </Table.Td>
      <Table.Td>
        <Skeleton height="20px" />
      </Table.Td>
    </Table.Tr>
  );
};
